<template>
    <div  style="position: absolute;top: 0;right: 0;bottom: 0;left: 0;display: flex;flex-direction: column">
        <van-nav-bar title="援助审批" left-arrow @click-left="onClickLeft" />
        <assistance-list :user-type="userTypes.lawyer" :open-id="openId" style="flex: 1;background-color: rgb(247, 248, 250);overflow: scroll"/>
        <van-tabbar v-model="active">
            <van-tabbar-item  icon="home-o">记录</van-tabbar-item>
            <van-tabbar-item  icon="chat-o" >我的回复</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    import AssistanceList from './AssistanceList';
    import {userTypes} from '../../common/const'
  export default {
    name: "LawyerAssistance",
    data() {
      return {
        active:0,
        userTypes,
      };
    },
    components: {
      AssistanceList
    },
    computed:{
      openId(){
        if(this.active===0){
          return null
        }else{
          return  this.$store.state.user.openId
        }
      }
    },
    methods:{

      onClickLeft() {
        this.$router.back();
      },
    }
  }
</script>

<style scoped>

</style>